import { useMemo } from "preact/hooks";
import { Masthead } from "../components/Masthead";
import { Email } from "../components/CourseView";
import { idx, unitColor } from "../store";
import { personKey, toMin } from "../lib/text";
import { DAYS } from "../lib/planner";
import { day } from "../i18n";
import type { Lecturer } from "../lib/types";

export function TeacherPage({ tid }: { tid: string }) {
  const I = idx.value!;
  const key = decodeURIComponent(tid).replace(/-/g, " ");
  const data = useMemo(() => {
    const person = I.core.people.find((p) => personKey(p.name) === key);
    const courses = I.core.courses.filter((c) => (c.lecturers || []).some((l) => personKey(l.name) === key));
    const sessions = I.core.sessions.filter((s) => s.lecturer && s.lecturer.split(/[,;/]| i (?=[A-ZČĆŠĐŽ])/).some((n) => personKey(n) === key));
    for (const s of sessions) if (!courses.some((c) => c.id === s.course_id)) courses.push(I.courses.get(s.course_id)!);
    const lect: Lecturer | undefined = person ? { name: person.name, email: person.email, email_verified: person.email_verified } : courses.flatMap((c) => c.lecturers || []).find((l) => personKey(l.name) === key);
    return { person, courses: courses.filter(Boolean), sessions: sessions.sort((a, b) => DAYS.indexOf(a.day) - DAYS.indexOf(b.day) || toMin(a.start)! - toMin(b.start)!), lect };
  }, [key]);
  const name = data.lect?.name || data.sessions[0]?.lecturer || key;
  document.title = `${name} · Slušam`;
  return (
    <>
      <Masthead compact />
      <div class="page">
        <div class="crumbs"><a href="/">Katalog</a> / nastavnik</div>
        <h1 style="font:400 44px/1.05 var(--display);margin:.2rem 0">{name}</h1>
        {data.person?.department && <p class="note">{data.person.fac} · {data.person.department}</p>}
        {data.lect && <p><Email l={data.lect} /></p>}
        <h3 style="font:500 22px var(--display)">Predmeti</h3>
        <ul>{data.courses.map((c) => <li key={c.id}><a href={`/c/${encodeURIComponent(c.id)}`} style={`color:${unitColor(c.fac)}`}>{c.name}</a> <span class="note">{c.fac}{c.year ? ` · god. ${c.year}` : ""}</span></li>)}</ul>
        <h3 style="font:500 22px var(--display)">Termini ove sedmice</h3>
        {data.sessions.length ? (
          <table class="plain"><thead><tr><th>Dan</th><th>Vrijeme</th><th>Predmet</th><th>Tip</th><th>Sala</th></tr></thead>
            <tbody>{data.sessions.map((s) => { const c = I.courses.get(s.course_id)!; return (
              <tr key={s.key}><td>{day(s.day)}</td><td class="mono">{s.start}–{s.end}</td><td><a href={`/c/${encodeURIComponent(c.id)}`}>{c.name}</a></td><td>{s.kind}</td><td>{s.room && <a href={`/r/${c.fac}/${encodeURIComponent(s.room)}`}>{s.room}</a>}</td></tr>
            ); })}</tbody></table>
        ) : <p class="note">Nema termina u objavljenim rasporedima.</p>}
        <p class="note" style="margin-top:1rem">Termini pokazuju kada je nastavnik na fakultetu. Konsultacije se dogovaraju posebno.</p>
      </div>
    </>
  );
}
